import {
  Box,
  Card,
  CardContent,
  Container,
  Stack,
  Typography,
} from '@mui/material';
import React from 'react';
import { useStylesCustom } from '../../../modules/dashboard/components/DashboardCardItem';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';

type CustomHeaderProps = {
  title: string;
  subtitle: string;
};
export const WarningMaintenance: React.FC<CustomHeaderProps> = ({
  title,
  subtitle,
}) => {
  const classes = useStylesCustom();

  return (
    <Container
      style={{ padding: '0px 0px', marginBottom: '16px' }}
      maxWidth={'lg'}
    >
      <Card
        style={{
          padding: '16px 34px',
          borderRadius: '16px',
          boxShadow: '0px 0px 8px 0px #00000014',
          background: '#ff3c41',
        }}
      >
        <CardContent className={classes.content}>
          <Stack
            display={'flex'}
            direction={{ xs: 'column-reverse', md: 'row' }}
            alignItems={'center'}
            justifyContent={'space-between'}
          >
            <Box marginBottom={{ xs: '10px', md: '0px' }}>
              <Typography
                marginBottom={{ xs: '5px', md: '10px' }}
                textAlign={{ xs: 'center', md: 'start' }}
                lineHeight={{ sx: '24px', md: '24px' }}
                fontSize={{ sx: '16px', md: '24px' }}
                color={'white'}
                fontWeight={700}
              >
                {title}
              </Typography>
              <Typography
                textAlign={{ xs: 'center', md: 'start' }}
                color={'white'}
                lineHeight={{ sx: '24px', md: '16px' }}
                fontSize={{ sx: '14px', md: '16px' }}
              >
                {subtitle}
              </Typography>
            </Box>
            <Box
              display={'flex'}
              alignItems={'center'}
              sx={{ height: '45px', position: 'relative', color: 'white' }}
            >
              <ReportGmailerrorredIcon color="inherit" fontSize="large" />
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </Container>
  );
};
